import Router from 'bpm-router';

import { bindEvents } from './helpers';

import Config from './configs/main.json';

import ModuleController from './controller/module';
import Skrollex from './components/skrollex';

class App {

	constructor() {
		this.el = {};

		this.events = bindEvents(this);

		this.addEventListeners();
	}

	init() {
		ModuleController.initialize();

		this.skrollex = new Skrollex();
	}

	initRouter() {
		Router.root = Config.root;
		Router.start({
			'/': () => {
				// this.open('home');
			},
			'/404': () => {
				// this.open('404');
			},
			// '/:page': (page) => {
			// 	this.open(page);
			// },
			// '/:id/:a/?:b': (id, a, b) => {
			// 	console.log(id, a, b);
			// }
		});
	}

	open() {
		// id
		// page controller request page html (template & data controller?) and save active page
		// module controller scan page DOM for known class selector, initialize modules and save module class reference in array
		// this.overrideAnchors();

		// ...
		// import App from './app';
		// App.open('page-id');
	}

	_onDOMContentLoaded() {
		this.init();
		this.initRouter();
	}

	_onWindowLoad() {
		// styles loaded
	}

	_onAnchorClick(e) {
		e.preventDefault();
		Router.navigate(e.currentTarget.getAttribute('href'));
	}

	overrideAnchors() {
		const anchors = document.querySelectorAll('a:not([href*="http"]):not([href*="tel"]):not([data-bypass])');
		for (const a of anchors) {
			a.removeEventListener('click', this.events._onAnchorClick);
			a.addEventListener('click', this.events._onAnchorClick);
		}
	}

	addEventListeners() {
		document.addEventListener('DOMContentLoaded', this.events._onDOMContentLoaded);
		window.addEventListener('load', this.events._onWindowLoad);
	}

}

export default new App();
